import React from 'react';
import { Grid } from '@mui/material';
import { ButtonWrapper } from '../layout/button-wrapper';
import { FieldAutomationIds } from '../../../../TCSMApp/global/constants/field-automation-ids';


interface FormButtonProps {
    submitText: string;
    cancelText: string;
    onCancel: () => any;
    onSubmit: () => any;
    disabled: boolean;
    submitDisabled?: boolean;
    hideCancelButton?: boolean;
    helperText?: string;
}

export function FormButtons(props: FormButtonProps) {

    return (
        <>
            <ButtonWrapper>
                <>
                    {
                        !props.hideCancelButton &&

                        <button data-testid={FieldAutomationIds.formCancelButton} className='btn-secondary' type='button' disabled={props.disabled} onClick={props.onCancel}>{props.cancelText}</button>
                    }
                    <button data-testid={FieldAutomationIds.formSubmitButton} className='btn-primary' type='submit' disabled={props.disabled || props.submitDisabled} onClick={props.onSubmit}>{props.submitText}</button>
                </>
            </ButtonWrapper>
            {props.helperText && <Grid container direction="row" justifyContent="flex-end"><Grid
                justifyContent="flex-end"
                container
                item md={6}><p>{props.helperText}</p>
            </Grid></Grid>}
        </>
    );
}

FormButtons.defaultProps = {
    submitDisabled: false,
    hideCancelButton: false,
    helperText: '',
};
